/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "LineItem": {
                "fields": {
                  "productSku": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitPriceMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "clientCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "packingMethod": {
                    "type": "squareup.solidshop.model.LineItem.PackingMethod",
                    "id": 5,
                    "rule": "optional"
                  },
                  "shippingMethod": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "internalProductName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "promoTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "includedTaxTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "additionalTaxTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "adjustmentTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "humanReadableName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "isTablet": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "riskProductType": {
                    "type": "squareup.solidshop.model.LineItem.RiskProductType",
                    "id": 14,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PackingMethod": {
                    "values": {
                      "OVERPACK": 1,
                      "SHIP_ALONE": 2
                    }
                  },
                  "RiskProductType": {
                    "values": {
                      "UNKNOWN": 0,
                      "TABLET": 1,
                      "MAGSTRIPE": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE LineItem @ squareup/solidshop/model/line_item.proto at 10:1
 */
export const LineItem = $root.lookupType('squareup.solidshop.model.LineItem');
fixType(LineItem);
Builder.createAndAttachToType(LineItem);
/**
 * SOURCE PackingMethod @ squareup/solidshop/model/line_item.proto at 11:3
 */
LineItem.PackingMethod = $root.lookupEnum('squareup.solidshop.model.LineItem.PackingMethod').values;
/**
 * SOURCE RiskProductType @ squareup/solidshop/model/line_item.proto at 16:3
 */
LineItem.RiskProductType = $root.lookupEnum('squareup.solidshop.model.LineItem.RiskProductType').values;
